import axios from "axios";
import { LandingTitle, Loader, PageLayout } from "../../components/index";
import { images } from "../../utils/images";
import ProjectList from "./projectsList/ProjectList";
import { baseUrl, getProject, projectCategory } from "../../utils/apiData";
import { Fragment, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";

const Projects = () => {

  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [category, setCategory] = useState([]);

  const { type } = useParams();

  //Category APi
  const getProjectCategotyApi = async () => {
    try {
      const res = await axios.get(`${baseUrl}/${projectCategory}`);
      if (res?.data?.success) {
        setCategory(res?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };


  // Get Project List API
  const getProjectsApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getProject}`);
      if (res?.data?.success) {
        setData(
          res?.data?.data?.filter((ele) => ele?.project_category === type)
        );
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getProjectCategotyApi();
    getProjectsApi();
  }, [type]);

  return (
    <PageLayout>
      <Helmet>
        <title>Project | Exotic Group</title>
        <meta name="description" content="Project | Exotic Group" />
      </Helmet>
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <LandingTitle
            bgImage={images.galleryLanding}
            title={type === "Contractor" ? "As a Contractor" : "As a Builder"}
            para=""
          />
          <ProjectList category={category} dataList={data} />
        </Fragment>
      )}
    </PageLayout>
  );
};

export default Projects;
